<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Clients" :options="f.clients" label="name" index="id" multiple v-model="filters['clients']" @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin">
        <v-select placeholder="User" :options="f.users" label="name" index="id" v-model="filters['user']" @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin">
        <v-select placeholder="Order" :options="orders" label="name" index="id" v-model="filters['order']" @input="loadTasks" multiple=""></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Tags" :options="f.taskTags" v-model="filters['tags']" @input="loadTasks" multiple=""></v-select>
      </div>
    </div>
    <div class="row m-b-sm">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Status" :options="statuses" multiple v-model="filters['status']" @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Blockers" :options="blockers" index="index" label="txt" v-model="filters['blocked']" @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Types" :options="user.admin ? types : user.roles" v-model="filters['type']" multiple @input="loadTasks"></v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <v-select placeholder="Priority" :options="['low', 'medium', 'high']" v-model="filters['priority']" multiple @input="loadTasks"></v-select>
      </div>
    </div>
    <button class="button btn btn-xs btn-success" @click="loadTasks"><i class="fa fa-search"></i> Find</button>
  </div>
</template>
<script>
import axios from 'axios'
import { Query } from '../../../../mixins/helperMixin'
import { TASKS_SET } from '../../../../store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      filters: {},
      statuses: [
        'assigned', 'completed', 'created', 'closed'
      ],
      blockers: [
        {index: null, txt: 'All'},
        {index: true, txt: 'Blocked'},
        {index: false, txt: 'Not Blocked'}
      ],
      types: [
        'content', 'fix', 'tech', 'link', 'build'
      ]
    }
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    if (!this.orders.length) {
      this.$store.dispatch('loadMaintenanceOrders', 'status=open')
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser',
      orders: 'getMaintenanceOrders'
    })
  },
  mixins: [Query],
  methods: {
    loadTasks () {
      axios.get(`/maintenance/tasks?${this.buildQuery(this.filters)}`)
        .then(r => {
          this.$store.commit(TASKS_SET, r.data.data)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Tasks/Filters.vue